// extracted by mini-css-extract-plugin
module.exports = {"dayContainer":"_nextSesions_dayContainer__rPkEX","dayDivider":"_nextSesions_dayDivider__3tfbp","dayLabels":"_nextSesions_dayLabels__2avl1"};